import { EmailConfirm } from 'feature/emailConfirm/EmailConfirm'
import { MainLayout } from 'layouts'

export function EmailConfirmPage() {
  return (
    <MainLayout>
      <div className='container'>
        <EmailConfirm />
      </div>
    </MainLayout>
  )
}
